import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext'; // Add this line
import BSignUp from './components/client/BSign-up';
import Header from "./components/Header";
import Sidebar from './components/SideBar';
import MainContent from "./components/client/MainContent";
import Footer from "./components/Footer";
import NotificationPopup from "./components/NotificationPopup";
import SearchBar from './components/client/Search';
import ProfessionalsSection from './components/client/ProfessionalsSection';
import ProjectsSection from "./components/client/ProjectsSection";
import Pagination from './components/pagination';
import ProjectDetails from './components/client/ProjectDetails';
import ProfessionalList from './components/client/ProfessionalList';
import ProjectList from './components/client/ProjectList';
import FiltersModal from './components/client/FiltersModal';
import CompleteProjectModal from './components/client/CompleteProjectModal';
import AvailProjectDetail from './components/client/avail_project_detail';
import ProjectFormContent from './components/client/ProjectFormContent';
import Login from './components/client/Login';
import UserManagement from './components/admin/UserManagement';
import AdManagement from './components/admin/AdManagement';
import DashboardContent from './components/admin/dashboard-content';
import ProtectedRoute from './ProtectedRoute';
import { useLanguage } from './contexts/LanguageContext';

const AppRoutes = () => {
  const { user } = useAuth(); // Add this line
  const { t } = useLanguage();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [isFiltersModalOpen, setIsFiltersModalOpen] = useState(false);
  const [isCompleteProjectModalOpen, setIsCompleteProjectModalOpen] = useState(false);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [filters, setFilters] = useState({}); // Define filters state

  useEffect(() => {
  }, []);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const toggleNotification = () => setIsNotificationOpen(!isNotificationOpen);
  const toggleFiltersModal = () => setIsFiltersModalOpen(!isFiltersModalOpen);
  const openCompleteProjectModal = (projectId) => {
    setSelectedProjectId(projectId)
    setIsCompleteProjectModalOpen(true)
  };
  const closeCompleteProjectModal = () => setIsCompleteProjectModalOpen(false);

  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = (query) => {
    setSearchQuery(query);
  };
 

  return (
    <Routes>
      <Route path="/" element={
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: 'var(--bg-base)' }}>
          <Header type="main" />
          <div style={{ display: 'flex', flex: 1 }}>
            <MainContent showSections={false} />
          </div>
          <Footer />
        </div>
      } />

      <Route path="/BSign-up" element={
         <div style={{ fontFamily: 'var(--font-body)', color: 'var(--text-primary)', background: 'var(--bg-base)', minHeight: '100vh' }}>
          <Header type="BusSignUp" />
          <BSignUp />
          <Footer />
         </div>
      } />

      
      <Route path="/Login" element={
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: 'var(--bg-base)' }}>
          <Header type="proSignUp" />
          <main style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ maxWidth: '672px', width: '100%' }}>
              <h1 style={{ textAlign: 'center', fontSize: '1.5rem', marginBottom: '32px', color: 'var(--text-primary)', fontFamily: 'var(--font-display)' }}>{t('loginToDevGenius')}</h1>
              <Login />
            </div>
          </main>
          <Footer />
        </div>
      } />

      <Route path="/BHome" element={
        <ProtectedRoute allowedRoles={['client']}>
          <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: 'var(--bg-base)' }}>
              <Header toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} />            
            <div style={{ display: 'flex', flex: 1 }}>              
              <Sidebar isOpen={isSidebarOpen} role={user?.role || 'guest'} />              
              <MainContent toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
            </div>
            <Footer />
            <NotificationPopup isOpen={isNotificationOpen} onClose={() => setIsNotificationOpen(false)} userId={user?.id || 0} />
          </div>
        </ProtectedRoute>
      } />
      
      <Route path="/Profiles" element={ 
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: 'var(--bg-base)' }}>
          {user?.role === 'client' ? (
            <Header toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} />
          ) : (
            <Header type="main" />
          )}
          <SearchBar onSearch={handleSearch} />
          <div style={{ display: 'flex', flex: 1 }}>
            {user?.role === 'client' && (
              <Sidebar isOpen={isSidebarOpen} role={user?.role || 'guest'} />
            )}
            <div style={{ flex: 1, transition: 'margin-left 0.3s ease', marginLeft: user?.role === 'client' && isSidebarOpen ? '384px' : '0' }}>
              <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '16px 32px' }}>
                <ProfessionalsSection
                  searchQuery={searchQuery} />
              </div>
              <Pagination />
            </div>
          </div>
          <Footer />
          <NotificationPopup isOpen={isNotificationOpen} onClose={() => setIsNotificationOpen(false)} userId={user?.id || 0} />
       </div>
      } />

      <Route path="/Projects" element={
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: 'var(--bg-base)' }}>
          {user?.role === 'client' ? (
              <Header toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} />
            ) : (
              <Header type="main" />
            )}
          <SearchBar onSearch={handleSearch} />
          <div style={{ display: 'flex', flex: 1 }}>
            {user?.role === 'client' && (
                <Sidebar isOpen={isSidebarOpen} role={user?.role || 'guest'} />
            )}
            <div style={{ flex: 1, transition: 'margin-left 0.3s ease', marginLeft: isSidebarOpen ? '384px' : '0' }}>      
              <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '16px 32px' }}>
                <ProjectsSection searchQuery={searchQuery} />
              </div>
              <Pagination />
            </div>
          </div>
          <Footer />
          <NotificationPopup isOpen={isNotificationOpen} onClose={() => setIsNotificationOpen(false)} userId={3} />
       </div>       
      } />

      <Route path="/ProjectMap/:id" element={
        <ProtectedRoute allowedRoles={['client', 'admin']}>
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: 'var(--bg-base)' }}>
          <Header toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} />
          <div style={{ display: 'flex', flex: 1 }}>
            <Sidebar isOpen={isSidebarOpen} role={user?.role || 'guest'} />
            <main id="main-content" style={{ flex: 1, transition: 'margin-left 0.3s ease', marginLeft: isSidebarOpen ? '384px' : '0' }}>
              <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '16px 32px' }}>
                <ProjectDetails />
                <ProfessionalList />
              </div>
            </main>
          </div>
          <Footer />
          <NotificationPopup isOpen={isNotificationOpen} onClose={() => setIsNotificationOpen(false)} userId={user?.id || 0} />
        </div>
        </ProtectedRoute>
      } />

      <Route path="/MyProject" element={ 
        <ProtectedRoute allowedRoles={['client']}>
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: 'var(--bg-base)' }}>
          <Header toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} />
        <div style={{ display: 'flex', flex: 1 }}>
          <Sidebar isOpen={isSidebarOpen} role="client" />
          <main style={{ flex: 1, transition: 'margin-left 0.3s ease', marginLeft: isSidebarOpen ? '384px' : '0' }}>
            <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '16px 32px' }}>
              <ProjectList 
                toggleFiltersModal={toggleFiltersModal} 
                openCompleteProjectModal={openCompleteProjectModal} 
                userId={user?.id || 0} 
                filters={filters} 
                setFilters={setFilters} 
              />
            </div>
          </main>
        </div>
        <Footer />
        <NotificationPopup isOpen={isNotificationOpen} onClose={() => setIsNotificationOpen(false)} userId={user?.id || 0} />
        <FiltersModal
          isOpen={isFiltersModalOpen}
          onClose={() => setIsFiltersModalOpen(false)}
          filters={filters}
          setFilters={setFilters}
        />
        <CompleteProjectModal
          isOpen={isCompleteProjectModalOpen}
          onClose={closeCompleteProjectModal}
          projectId={selectedProjectId}
        />
      </div>
      </ProtectedRoute>
      } />

      <Route path="/AvailProjectDetail/:projectlId" element={
        <ProtectedRoute allowedRoles={['client', 'admin', 'professional']}>
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: 'var(--bg-base)' }}>
        <Header toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} />  
        <div style={{ display: 'flex', flex: 1 }}>
            <Sidebar isOpen={isSidebarOpen} role={user?.role || 'guest'} />
          <main style={{ flex: 1, transition: 'margin-left 0.3s ease', marginLeft: isSidebarOpen && user?.role === 'client' ? '384px' : '0' }}>
            <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '16px 32px' }}>  
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '32px' }}>
                <AvailProjectDetail/>
              </div>
            </div>
          </main>
        </div>  
        <NotificationPopup isOpen={isNotificationOpen} onClose={() => setIsNotificationOpen(false)} userId={user?.id || 0} />   
        <Footer />
      </div>
      </ProtectedRoute>
      } />

      <Route path="/ReqProject" element={
        <ProtectedRoute allowedRoles={['client']}>
          <div style={{ fontFamily: 'var(--font-body)', color: 'var(--text-primary)', background: 'var(--bg-base)', minHeight: '100vh' }}>
            <Header toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} />
            <div style={{ display: 'flex', flex: 1 }}>
              <Sidebar isOpen={isSidebarOpen} role="client" />
              <main style={{ flex: 1, transition: 'margin-left 0.3s ease', marginLeft: isSidebarOpen ? '384px' : '0' }}>
                <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '16px 32px' }}>
                  <ProjectFormContent />
                </div>
              </main>
            </div>
            <Footer />
            <NotificationPopup isOpen={isNotificationOpen} onClose={() => setIsNotificationOpen(false)} userId={user?.id || 0} />
          </div>
        </ProtectedRoute>
      } />

      <Route path="/userMange" element={
        <ProtectedRoute allowedRoles={['admin']}>
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: 'var(--bg-base)' }}>
        <Header toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} />
  
        <div style={{ display: 'flex', flex: 1 }}>
          <Sidebar isOpen={isSidebarOpen} role="admin" />  
  
          <main
            id="main-content"
            style={{ flex: 1, transition: 'margin-left 0.3s ease', marginLeft: isSidebarOpen ? '384px' : '0' }}
          >
            <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '16px 32px' }}>  
              <UserManagement/>
            </div>
          </main>
        </div>  
        <Footer />
        <NotificationPopup isOpen={isNotificationOpen} onClose={() => setIsNotificationOpen(false)} userId={user?.id || 0} />
      </div>
      </ProtectedRoute>
      } />

      <Route path="/Ads" element={
        <ProtectedRoute allowedRoles={['admin']}>
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: 'var(--bg-base)' }}>
        <Header toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} />
  
        <div style={{ display: 'flex', flex: 1 }}>
          <Sidebar isOpen={isSidebarOpen} role="admin" />
  
          <main style={{ flex: 1, transition: 'margin-left 0.3s ease', marginLeft: isSidebarOpen ? '384px' : '0' }}>
            <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '16px 32px' }}>  
              <AdManagement />
            </div>
          </main>
        </div>
        <Footer />
        <NotificationPopup isOpen={isNotificationOpen} onClose={() => setIsNotificationOpen(false)} userId={user?.id || 0} />
      </div>
      </ProtectedRoute>
      } />

      {/*<Route path="/AdminDashboard" element={
        <div className="flex flex-col min-h-screen bg-gray-50">
          <Header toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} />
          <div className="flex flex-grow">
            <Sidebar isOpen={isSidebarOpen} />
            <AdminDashboard />
          </div>
          <Footer />
        </div>
      } />*/}
      <Route path="/AdminDashboard" element={
        <ProtectedRoute allowedRoles={['admin']}>
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: 'var(--bg-base)' }}>
        <Header toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} />
      <div style={{ display: 'flex', flex: 1 }}>
        <Sidebar isOpen={isSidebarOpen} role="admin" />
        <main style={{ flex: 1, transition: 'margin-left 0.3s ease', marginLeft: isSidebarOpen ? '384px' : '0' }}>
            <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '16px 32px' }}>  
            <DashboardContent/>
            </div>
          </main>        
      </div>
      <Footer />
      <NotificationPopup isOpen={isNotificationOpen} onClose={() => setIsNotificationOpen(false)} userId={user?.id || 0} />
    </div>
    </ProtectedRoute>
  } />
    </Routes>
  );
};

export default AppRoutes;